<template>
  <div class="modal-background">
    <div class="modal-box component-center flex-col flex-center">
      <p>{{ modalContent }}</p>
      <button
        @click="
          () => {
            closeModal();
          }
        "
      >
        OK
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'Modal',
  methods: {
    ...mapActions('modal', ['AC_MODAL_CLOSE']),
    closeModal() {
      if (this.modalUrl) {
        this.$router.push(this.modalUrl);
      }
      this.AC_MODAL_CLOSE();
    },
  },
  computed: {
    ...mapState('modal', ['modalContent', 'modalUrl']),
  },
};
</script>

<style lang="scss" scoped>
.modal-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;

  background: #00000020;
}

.modal-box {
  width: 300px;
  height: 150px;
  padding: 20px;
  border: 2px solid $MAIN-COLOR;
  border-radius: 10px;
  background: white;
  box-shadow: 0 0 10px 0 #00000030;
  text-align: center;

  p {
    font-size: 1.1rem;
  }
  button {
    margin-top: 20px;
    padding: 8px 15px;
    border: 5px;
    background: $MAIN-COLOR;
    color: white;
  }
}
</style>
